import React from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";

export default function StoreProductDeleteModal({
  open,
  onClose,
  onConfirm,
  product,
  loading,
}) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="xs"
      PaperProps={{
        sx: {
          borderRadius: "16px",
        },
      }}
    >
      <DialogTitle
        sx={{
          fontSize: 18,
          fontWeight: 700,
          color: "#0f172a",
        }}
      >
        Eliminar producto
      </DialogTitle>

      <DialogContent sx={{ pt: "8px !important" }}>
        <Typography
          sx={{
            color: "#475569",
            fontSize: 14,
            fontWeight: 500,
            lineHeight: 1.6,
          }}
        >
          {product ? `Se eliminará ${product.name}.` : ""}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 2.4, pt: 0.8 }}>
        <Button
          onClick={onClose}
          variant="outlined"
          disabled={loading}
          sx={{
            height: 36,
            px: 1.4,
            borderRadius: "9px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 12.8,
            color: "#334155",
            borderColor: "rgba(51,65,85,0.18)",
            "&:hover": {
              borderColor: "rgba(51,65,85,0.28)",
              bgcolor: "rgba(148,163,184,0.08)",
            },
          }}
        >
          Cancelar
        </Button>

        <Button
          onClick={onConfirm}
          variant="contained"
          disabled={loading}
          sx={{
            height: 36,
            px: 1.4,
            borderRadius: "9px",
            textTransform: "none",
            fontWeight: 600,
            fontSize: 12.8,
            bgcolor: "#0f172a",
            boxShadow: "none",
            "&:hover": {
              bgcolor: "#111827",
              boxShadow: "none",
            },
          }}
        >
          {loading ? "Eliminando" : "Eliminar"}
        </Button>
      </DialogActions>
    </Dialog>
  );
}